// src/components/pages/Produto/tabs/CabecalhoTabPanel.jsx
import React from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';

import formStyles from '../../../form/Form.module.css';

import { retornaDataHora } from '../../../../utils/retornaDataFormatada';

// componentes do seu projeto (ajuste paths conforme seu projeto)
import SelectEmpresa from '../../../form/SelectEmpresa';
import Input from '../../../form/Input';
import InputNumber from '../../../form/InputNumber';
import Checkbox from '../../../form/Checkbox';
import Select from '../../../form/Select';
import DataList from '../../../form/DataList';

/* utils */
import { formatarNumero } from '../../../../utils/masks';
/**
 * Painel "Cabeçalho" do Produto
 * - Burro: só renderiza
 * - Toda lógica fica no Form/useModule
 */
const cabecalhoTabPanel = ({
    module,
    //options e enums
    OptionsEmpresa,
    EnumTipo,
    EnumOrigemCadastro,
    //parametros
    profile,
}) => {
    const {
        dados,
        Fabricante,
        OptionsFabricante,
        NCM,
        OptionsNCM,
        CEST,
        OptionsCEST,
        Grupo,
        OptionsGrupo,
        SubGrupo,
        OptionsSubGrupo,
        subGrupoLoading,
        bobinaCor,
        OptionsBobinaCor,
    } = module.state;
    const { change: onChange, focus: onFocus, blur: onBlur } = module.actions;

    const uiTab = profile.uiTabs.cabecalho;

    return (
        <div>
            <div className={formStyles.preview_bandeira}>
                <h4>{uiTab?.labels?.grid}</h4>
            </div>

            <div>
                <SelectEmpresa
                    name="empresaId"
                    text="Empresa"
                    options={OptionsEmpresa}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.empresaId}
                    isEnum={false}
                    notOptNull={true}
                />

                <Input
                    text="Data Cadastro"
                    type="datetime-local"
                    name="createdAt"
                    placeholder="última atualização"
                    title="Data de inserção do cadastro no sistema"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={(dados.createdAt && retornaDataHora(dados.createdAt)) || retornaDataHora(moment())}
                    readonly={true}
                />

                <Input
                    text="Data Atualização"
                    type="datetime-local"
                    name="updatedAt"
                    placeholder="última atualização"
                    title="Data da última atualização dos dados"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={(dados.updatedAt && retornaDataHora(dados.updatedAt)) || retornaDataHora(moment())}
                    readonly={true}
                />

                <Checkbox
                    title="Ativa ou Inativa o produto"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
                {uiTab?.show?.compra && (
                    <>
                        <Checkbox
                            title="Informa que o produto utiliza a rotina de compras"
                            text="Compra"
                            name="compra"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.compra}
                            checked={!!dados.compra}
                        />
                    </>
                )}
                {uiTab?.show?.venda && (
                    <>
                        <Checkbox
                            title="Informa que o produto utiliza a rotina de vendas"
                            text="Venda"
                            name="venda"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.venda}
                            checked={!!dados.venda}
                        />
                    </>
                )}
                {uiTab?.show?.locavel && (
                    <>
                        <Checkbox
                            title="Informa que o produto pode ser locado"
                            text="Locavel"
                            name="locavel"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.locavel}
                            checked={!!dados.locavel}
                        />
                    </>
                )}
                {uiTab?.show?.industria && (
                    <>
                        <Checkbox
                            title="Informa que o produto passa por processo de industrialização"
                            text="Indústria"
                            name="industria"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.industria}
                            checked={!!dados.industria}
                        />
                    </>
                )}
                {uiTab?.show?.servico && (
                    <>
                        <Checkbox
                            title="Informa que o item é um serviço"
                            text="Serviço"
                            name="servico"
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.servico}
                            checked={!!dados.servico}
                        />
                    </>
                )}
            </div>

            <div>
                <Input
                    text="Código"
                    type="text"
                    name="codigo"
                    placeholder="Código"
                    title="O sistema vai gerar um código para o produto"
                    minlength={14}
                    maxlength={18}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.codigo || ''}
                    readonly={true}
                    inputWidth={'150px'}
                />

                <Input
                    text="Descrição"
                    type="text"
                    name="descricao"
                    placeholder="Descrição"
                    title="digite a descrição do produto"
                    inputWidth="350px"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.descricao || ''}
                    readonly={false}
                />

                <Select
                    name="tipo"
                    text="Tipo"
                    title="Determina o tipo do produto"
                    options={EnumTipo}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.tipo}
                    isEnum={true}
                />
                <DataList
                    text="Grupo"
                    title={'Vincula o Grupo ao produto'}
                    name="Grupo.descricao"
                    inputWidth="200px"
                    filteredOptions={OptionsGrupo}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={Grupo?.descricao || ''}
                />
                <DataList
                    text="Subgrupo"
                    title={dados.grupoId ? 'Vincula o Subgrupo ao produto' : 'Selecione primeiro o Grupo'}
                    name="SubGrupo.descricao"
                    placeholder={
                        !dados.grupoId
                            ? 'Selecione primeiro o Grupo'
                            : subGrupoLoading
                              ? 'Carregando subgrupos...'
                              : OptionsSubGrupo?.length
                                ? 'Selecione o Subgrupo'
                                : 'Nenhum subgrupo cadastrado'
                    }
                    inputWidth="250px"
                    filteredOptions={OptionsSubGrupo}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={SubGrupo?.descricao || ''}
                    readonly={!dados.grupoId || subGrupoLoading || !OptionsSubGrupo?.length}
                />
                <Checkbox
                    title="Marca o produto para revisão"
                    text="Revisão"
                    name="pendenteRevisao"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.pendenteRevisao}
                    checked={!!dados.pendenteRevisao}
                />
                <Select
                    name="origemCadastro"
                    text="Origem do Cadastro"
                    title="Determina a origem do cadastro do produto"
                    options={EnumOrigemCadastro}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.origemCadastro}
                    isEnum={true}
                />
            </div>
            {profile?.id === 'bobina' && (
                <>
                    <InputNumber
                        text="Comprimento"
                        type="text"
                        name="bobinaComprimento"
                        placeholder="Comprimento"
                        inputWidth="100px"
                        title="digite o comprimento da bobina"
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados.bobinaComprimento ? formatarNumero(dados.bobinaComprimento) : ''}
                        required={true}
                    />
                    <InputNumber
                        text="Diâmetro"
                        type="text"
                        name="bobinaDiametro"
                        placeholder="Diâmetro"
                        inputWidth="100px"
                        title="digite o diâmetro da bobina"
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={dados.bobinaDiametro ? formatarNumero(dados.bobinaDiametro) : ''}
                        required={true}
                    />
                    <DataList
                        text="Cor da Bobina"
                        title={'Vincula a cor para a produção do produto'}
                        name="bobinaCor.descricao"
                        inputWidth="350px"
                        filteredOptions={OptionsBobinaCor}
                        handleOnChange={onChange}
                        handleOnFocus={onFocus}
                        handleOnBlur={onBlur}
                        value={bobinaCor?.descricao || ''}
                    />
                    <Checkbox
                        title="Bobina sanfonada"
                        text="Sanfonada"
                        name="bobinaSanfonada"
                        handleOnChange={onChange}
                        value={dados.bobinaSanfonada}
                        checked={!!dados.bobinaSanfonada}
                    />
                    <Checkbox
                        title="Bobina transparente"
                        text="Transparente"
                        name="bobinaTransparente"
                        handleOnChange={onChange}
                        value={dados.bobinaTransparente}
                        checked={!!dados.bobinaTransparente}
                    />
                    <Checkbox
                        title="Bobina tratada"
                        text="Tratada"
                        name="bobinaTratada"
                        handleOnChange={onChange}
                        value={dados.bobinaTratada}
                        checked={!!dados.bobinaTratada}
                    />
                </>
            )}
            <div>
                <Input
                    text="referência"
                    type="text"
                    name="referencia"
                    placeholder="Código de referência"
                    title="Digite o código de referência do produto"
                    minlength={14}
                    maxlength={18}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.referencia || ''}
                    inputWidth={'150px'}
                />

                <Input
                    text="Código Fabricante"
                    type="text"
                    name="codigoFabricante"
                    placeholder="Código Fabricante"
                    title="Digite o código do fabricante do produto"
                    minlength={14}
                    maxlength={18}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.codigoFabricante || ''}
                    inputWidth={'150px'}
                />

                <DataList
                    text="Fabricante"
                    title={'Vincula o Fabricante ao produto'}
                    name="Fabricante.descricao"
                    inputWidth="350px"
                    filteredOptions={OptionsFabricante}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={Fabricante?.descricao || ''}
                />
            </div>

            <div>
                <Input
                    text="NCM"
                    type="text"
                    name="NCM.ncm"
                    placeholder="NCM"
                    inputWidth="150px"
                    title="Código do ncm do produto"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={NCM?.ncm}
                    readonly={true}
                />

                <DataList
                    text="NCM Descrição"
                    title={'Vincula o NCM ao produto'}
                    name="NCM.descricao"
                    placeholder={'Digite mais de 3 caracteres para pesquisar'}
                    inputWidth="510px"
                    filteredOptions={OptionsNCM}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={NCM?.descricao}
                    required={true}
                />

                <DataList
                    text="CEST"
                    title={'Vincula o CEST ao produto'}
                    name="CEST.cest"
                    placeholder={'Digite o CEST'}
                    inputWidth="150px"
                    filteredOptions={OptionsCEST}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={CEST?.cest}
                />
            </div>
        </div>
    );
};
export default React.memo(cabecalhoTabPanel);
